export default __webpack_public_path__ + "static/media/warning--dip--g1.066fd9ff.png";